import React from 'react';
import { sortBy } from 'lodash';
import SelectionList from '../../../../../shared/components/SelectionList';

/**
 * @typedef {object} OhtSelectorProps
 * @property {Array<*>} ohts
 * @property {Array<*>} [selectedOhtIds]
 * @property {(selectedOhtIds: Array<number>) => void} setSelectedOhts
 * @property {boolean} [disabled]
 * @property {boolean} [loading]
 */

/**
 * @param {OhtSelectorProps} props
 */
export const OhtSelector = props => {
  const { ohts, setSelectedOhts, disabled, loading, selectedOhtIds = [] } = props;

  const options = sortBy(ohts, o => o.displayName);

  const handleSelected = selectedOhts => {
    const selectedOhtIds = selectedOhts.map(ou => ou.value);
    setSelectedOhts(selectedOhtIds);
  };

  return (
    <SelectionList
      id='select-oht'
      showInputEndAdornment={false}
      allowAutocomplete={false}
      onSelectHandler={handleSelected}
      selectedValue={getSelectedOptions(options, selectedOhtIds)}
      list={options}
      placeholder='Select OHT(s)'
      multiSelect={true}
      disabled={disabled}
      loading={loading}
    />
  );
};

const getSelectedOptions = (allOptions, selectedOptions) =>
  allOptions.filter(item => selectedOptions.includes(item.value));

export default OhtSelector;
